import { auth } from "../firebase"

// Goes through our backend, so the bot token never ships in the bundle.
const FRONTEND_TELEGRAM_URL =
  "https://europe-west3-upscaler-89296.cloudfunctions.net/frontend_telegram"

export const telegram = async (message) => {
  try {
    const headers = { "Content-Type": "application/json" }
    // Optional: lets the backend log the uid next to the message.
    const token = await auth.currentUser?.getIdToken().catch(() => null)
    if (token) headers.Authorization = `Bearer ${token}`

    await fetch(FRONTEND_TELEGRAM_URL, {
      method: "POST",
      headers,
      body: JSON.stringify({ message: String(message) }),
      // Survive page navigations right after an error.
      keepalive: true,
    })
  } catch (error) {
    console.error("Error while sending error notification:", error)
  }
}
